<div fxLayout="column" fxLayoutAlign="start center" fxFlexFill>

  <!-- Email form -->
  <div fxLayout="column" fxLayoutGap="10px" class="form-auth" ngClass.xs="full-w" *ngIf="smsApi.conditionSms()">

    <!-- Errors && Success messages -->

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'credentialinfomissing'">
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"registerComp.infoMissing" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'errHappen'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>warning</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"registerComp.error" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'erremailalreadyuse'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2" *ngIf="currEmail"
          [innerHTML]="'register.message.takenemail' | translate:{'email': currEmail}"></span>
        <span class="mat-subheading-2" *ngIf="!currEmail">{{"registerComp.takenemail" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn"
      *ngIf="error$ === 'errphoneinvalid' || error$ === 'errphonealreadytaken' || error$ === 'errnomobile'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>phone</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2" *ngIf="error$ === 'errphonealreadytaken'">{{"registerComp.takenphonenumber" |
          translate}}</span>
        <span class="mat-subheading-2" *ngIf="error$ === 'errphoneinvalid'">{{"registerComp.errorphonenumber" |
          translate}}</span>
        <span class="mat-subheading-2" *ngIf="error$ === 'errnomobile'">{{"registerComp.errormobil" | translate}}</span>
      </div>
    </mat-card>


    <!-- Register Form -->
    <form fxLayout="column" fxLayoutGap="10px" [formGroup]="registerForm" #formDirective="ngForm"
      (ngSubmit)="submitRegister(formDirective)">

      <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column">

        <div class="form-field-endorder" fxFlex="50" fxFlex.xs="0">

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{"registerComp.name" | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'registerComp.name' | translate}}" formControlName="lastname">
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('lastname')">
              <span class="mat-caption">{{"registerComp.nameRequired" | translate}}</span>
            </mat-error>
          </mat-form-field>

        </div>

        <div class="form-field-endorder" fxFlex fxFlex.xs="0">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{"registerComp.firstname" | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'registerComp.firstname' | translate}}"
              formControlName="firstname">
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('firstname')">
              <span class="mat-caption">{{"registerComp.firstnameRequired" | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>

      </div>


      <!-- society -->
      <div class="form-field-endorder" fxFlex fxFlex.xs="0">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"adressComponent.soc" | translate}} <span style="font-size: 12px;">({{"optional" |
              translate}})</span></mat-label>
          <input type="text" matInput placeholder="{{'adressComponent.soc' | translate}}" formControlName="society">
        </mat-form-field>
      </div>



      <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column">

        <!-- Country -->

        <div class="form-field-endorder" fxFlex="30" fxFlex.xs>

          <mat-form-field appearance="outline" class="full-w">
            <mat-label>{{"registerComp.country" | translate}}</mat-label>
            <mat-select formControlName="id_country">

              <mat-select-trigger *ngIf="selectedCountry">
                <div class="flex flex-row items-center gap-3">
                  <img src="data:image/png;base64,{{selectedCountry.flag}}" class="h-3 rounded-sm">
                  <span class="text-sm">{{selectedCountry.name}}</span>
                </div>
              </mat-select-trigger>

              <mat-option *ngFor="let country of countries$" [value]="country.id" (click)="setSelectedCountry(country)">

                <div class="flex flex-row justify-start items-center gap-2.5">
                  <img *ngIf="country.flag" src="data:image/png;base64,{{country.flag}}" class="h-4 rounded-sm">
                  <span class="text-sm">{{country.name | uppercase}}</span>
                </div>

              </mat-option>

            </mat-select>
          </mat-form-field>

        </div>

        <!-- Phone -->
        <div class="form-field-endorder" fxFlex>

          <mat-form-field appearance="outline" class="full-w">
            <mat-label>{{"registerComp.mobile" | translate}}</mat-label>
            <input type="text" matInput placeholder="Mobile" formControlName="phone">
            <!-- <span matPrefix>{{selectedCountry ? '+ ' + selectedCountry.phone_calling_code : '+XX'}} &nbsp;</span> -->
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('phone')">
              <span class="mat-caption">{{"registerComp.mobileRequired" | translate}}</span>
            </mat-error>
            <mat-error fxLayout fxLayoutAlign="start center" *ngIf="registerForm.controls['phone'].errors?.pattern">
              <span class="mat-caption">{{"registerComp.invalidFormat" | translate}}</span>
            </mat-error>
          </mat-form-field>

        </div>

      </div>

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"main.word.email" | translate}}</mat-label>
          <input type="email" matInput placeholder="{{'main.word.email' | translate}}" formControlName="email"
            autocomplete="username">
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('email')">
            <span class="mat-caption">{{"main.err.reqemail" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="registerForm.controls['email'].errors?.email">
            <span class="mat-caption">{{"main.err.emailformat" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>

          <mat-label>{{"main.word.password" | translate}}</mat-label>
          <input matInput type="password" placeholder="{{'main.word.password' | translate}}" formControlName="password"
            autocomplete="new-password">
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('password')">
            <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="registerForm.controls['password'].errors?.minlength">
            <span class="mat-caption">{{"main.err.passformat" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{'main.word.verifpass' | translate}}</mat-label>
          <input matInput type="password" placeholder="{{'main.word.verifpass' | translate}}"
            formControlName="confPassword" autocomplete="new-password">
          <mat-error fxLayout fxLayoutAlign="start center" class="input-fullw" *ngIf="isFieldrequired('confPassword')">
            <span class="mat-caption">{{"main.err.verifpassreq" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" class="input-fullw"
            *ngIf="registerForm.controls['confPassword'].errors?.MatchPassword">
            <span class="mat-caption">{{"main.err.nomatch" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <!-- enable_marketing -->
      <section id="enable_marketing" fxLayout="row" fxLayoutAlign="start center" style="padding:0 0 20px 5px;">

        <mat-checkbox formControlName="enable_marketing" color="primary" (change)="onChkChange($event)">
          <span class="mat-subheading-1" ngClass.xs="mat-caption"
            style="width: 15px">{{"enable_marketing.acceptTerms"|translate}}</span>
        </mat-checkbox>

      </section>


      <button [ngClass]="cssService.defaultActionButton" angulartics2On="click"
        angularticsAction="submitRegisterForm" angularticsCategory="register">{{"main.word.register" |
        translate}}</button>

    </form>

    <!-- Credentials -->
    <div fxLayout="column" class="full-w">
      <app-credentials [currEmail]="currEmail" [redirectPage]="redirectPage" [registerForm]="registerForm"
        (setUserInfoInputsEvent)="setUserInfoInputs($event)">
      </app-credentials>
    </div>

  </div>

  <!-- Code sms form

  <div fxLayout="column" fxLayoutGap="10px" class="form-auth" ngClass.xs="full-w" *ngIf="!smsApi.conditionSms()">

    <div fxLayoutAlign="center center layout-padd" class="text-center">
      <span class="mat-subheading-1">{{"registerComp.smsCode" | translate}}</span>
    </div>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="errorCodeSmsNotifMessage">
      <span class="mat-subheading-2">{{errorCodeSmsNotifMessage}}</span>
    </mat-card>

    <div class="full-w">
      <mat-form-field appearance="outline" class="form-nopadd" fxFlex>
        <mat-label>Code Sms</mat-label>
        <input type="text" placeholder="Code sms" [(ngModel)]="smsNotifInputValue" matInput>
      </mat-form-field>
    </div>


    <button mat-raised-button color="primary" (click)="getSmsNotif()"
      [disabled]="!smsNotifInputValue || smsNotifInputValue.length < 6">{{"registerComp.verify" | translate}}</button>

  </div>-->

  <app-popup-loader [flagLoading]="loaders.page" [size]="30">
  </app-popup-loader>

</div>
